import { createVanIconComponent } from "./van"

const GoldCoin = createVanIconComponent("gold-coin")
export default GoldCoin
